export default "__VITE_ASSET__CRmuPhRO__"